import React, { memo } from "react";
import cx from "classnames";
import { css } from "@linaria/core";
import { colors } from "@ui/Theme";

export const AnnotationIcon = memo(
  ({
    width,
    height,
    ...props
  }: React.ComponentProps<"div"> & { width?: number; height?: number }) => (
    <div
      className={cx(diagramEditorAnnotationMarker, {
        area: (width ?? 0) > 0 && (height ?? 0) > 0,
      })}
      {...props}
    />
  ),
);

const diagramEditorAnnotationMarker = css`
  width: 13px;
  height: 13px;
  color: ${colors.carbon800};

  &:not(.area) {
    background-color: currentColor;
    border-radius: 50%;
  }

  &.area {
    border: 2px solid currentColor;
    height: 11px;
  }
`;
